/** Read-only help search path: tenant/user identity is resolved by the BFF session, never the browser. */
export function supportSearchPath(question: string, locale: 'en' | 'ar'): `/v1/${string}` {
  const params = new URLSearchParams({ q: question.trim().slice(0, 200), locale });
  return `/v1/help-centre/search?${params.toString()}`;
}

export function canSearchSupport(surface: 'customer' | 'partner' | 'admin', tenantId: string | null | undefined): boolean {
  return surface === 'customer' && Boolean(tenantId);
}

/** Optional tenant-private AutoRAG retrieval. Never accept scope ids or raw index names from the browser. */
export function supportKnowledgePath(question: string): `/v1/${string}` {
  const params = new URLSearchParams({ q: question.trim().slice(0, 200) });
  return `/v1/auto-rag/search?${params.toString()}`;
}

export type SupportKnowledgeHit = {
  label: string;
  text: string;
  sourceId: string;
  sourceVersion: number;
  sourceUpdatedAt?: string;
};

/** Only the server's verified, versioned citations are eligible for private Support display.
 * Missing/unknown source identity never becomes a generic 'verified' citation.
 */
export function parseSupportKnowledgeHits(payload: unknown): SupportKnowledgeHit[] {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return [];
  const data = payload as Record<string, unknown>;
  const rows = Array.isArray(data.chunks) ? data.chunks : [];
  return rows
    .filter((row): row is Record<string, unknown> => !!row && typeof row === 'object' && !Array.isArray(row))
    .filter((row) =>
      typeof row.text === 'string' && row.text.trim().length > 0 &&
      typeof row.title === 'string' && row.title.trim().length > 0 &&
      typeof row.source_id === 'string' &&
      /^rag_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(row.source_id) &&
      typeof row.source_version === 'number' && Number.isInteger(row.source_version) && row.source_version >= 1
    )
    .slice(0, 5)
    .map((row) => ({
      label: String(row.title).slice(0, 160),
      text: String(row.text).slice(0, 1200),
      sourceId: String(row.source_id),
      sourceVersion: Number(row.source_version),
      ...(typeof row.source_updated_at === 'string' ? { sourceUpdatedAt: row.source_updated_at } : {}),
    }));
}
